import { StyledRequestsPage } from './styled';
import { ImageLazy } from 'components/ImageLazy';
import { Images } from 'assets/images';
import { LazyContainer } from 'components/ImageLazy/styled';
import { useCustomNavigation } from 'hooks';
import {
  BackToPreviousPageIcon,
  RequestsText,
  TopContainer,
  RequestsFullWrapper,
  FullInsideContainer,
} from 'containers/Requests/fragments/RequestsCountries/styled';

export const RequestsPageLayout = ({ children }) => {
  const { back } = useCustomNavigation();

  return (
    <StyledRequestsPage>
      <LazyContainer>
        <ImageLazy
          src={Images.settingsBackgroundOrigin}
          width="100%"
          height="100%"
          hash="LzGml3Aui]WC_LJVjWWXohniW-j]"
        />
      </LazyContainer>
      <RequestsFullWrapper>
        <FullInsideContainer>
          <TopContainer>
            <BackToPreviousPageIcon src={Images.backVectorIcon} onClick={back} />

            <RequestsText>Requests</RequestsText>
          </TopContainer>
        </FullInsideContainer>
        {children}
      </RequestsFullWrapper>
    </StyledRequestsPage>
  );
};
